/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:ccQuestionari
 * @restrict E
 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
 */
(function () {
  'use strict';
  var TlpsPostVenditaTelepassCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    postVenditaSrvc,
    uiGridConstants,
    $state,
    $uibModal
  ) {
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    this.postVenditaSrvc = postVenditaSrvc;
    this.$uibModal = $uibModal;

    this.uiGridConstants = uiGridConstants;

    this.ndg;
    this.contrattiSelezionati = [];
    this.ragioneSociale;

    this.tableHeight = 0;
    this.labelViacard = 'VIACARD';
    this.labelTelepass = 'TELEPASS';
    this.carteSelezionate = [];
    this.codiceContrattoSelezionato = null;
    this.idContrattoSelezionato = null;

    this.isRestituzioneCarte = false;
    this.isAggiuntaCarte = false;
    this.isModificaConto = false;

    this.numeroCarteDaAggiungere = null;
    this.numeroRapportoDaModificare = null;
    var self = this;

    /*
     * ------------------------------------------------
     *           GESTIONE INTERFACCIA
     * ------------------------------------------------
     */

    this.avviaRestituzioneCarte = function (row) {
      self.codiceContrattoSelezionato = row.entity.codiceContratto;
      self.idContrattoSelezionato = row.entity.id;
      self.isRestituzioneCarte = true;
      self.isAggiuntaCarte = false;
      self.isModificaConto = false;
      self.carteSelezionate = [];
      self.recuperaCarte(row.entity.id, self.ndg);
    };

    this.recuperaConti = function (ndg) {
      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseRecuperaContiCorrenti(ndg)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.postVenditaSrvc.spinner.callStack--;
            return;
          }

          self.listaContiCorrenti = response.data.result;

          for (var i in self.listaContiCorrenti) {
            self.listaContiCorrenti[i].dataApertura = self.postVenditaSrvc.formattazioneData(
              self.listaContiCorrenti[i].dataApertura
            );
          }

          self.tableHeightConti = response.data.result.length * 30 + 40;

          // // Configurazione tabella
          self.gridOptionsContiCorrenti = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            multiSelect: false,
            showHeader: true,
            enableRowHeaderSelection: false,
            enableRowSelection: true,
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            columnDefs: [
              {
                displayName: 'Numero Rapporto',
                field: 'numeroRapporto',
                width: '10%',
                name: 'numeroRapporto'
              },
              {
                displayName: 'Iban',
                field: 'iban',
                width: '25%',
                name: 'iban'
              },
              {
                displayName: 'Descrizione',
                field: 'descrizione',
                width: '15%',
                name: 'descrizione'
              },
              {
                displayName: 'Saldo Contabile',
                cellFilter: 'number : 2',
                cellClass: 'right',
                field: 'saldoContabile',
                width: '10%',
                name: 'saldoContabile'
              },
              {
                displayName: 'Intestatario',
                cellClass: 'right',
                field: 'intestazione',
                width: '20%',
                name: 'intestazione'
              },
              {
                displayName: 'Stato',
                field: 'stato',
                width: '10%',
                name: 'stato'
              },
              {
                displayName: 'Data Apertura',
                field: 'dataApertura',
                cellFilter: 'date: "dd/MM/yyyy"',
                width: '10%',
                name: 'dataApertura'
              }
            ],
            data: self.listaContiCorrenti,
            onRegisterApi: function (gridApi) {
              self.gridApi = gridApi;
              self.gridApi.grid.modifyRows(self.gridOptions.data);

              gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                self.selezionaConto(row);
              });
            }
          };
        })
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.datiValidi = function () {
      var errori = false;

      //Controlla che un conto sia stato selezionato
      if (!self.numeroRapportoDaModificare) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un conto';
        messaggiFctr.addMessage(message);
        errori = true;
      }
      if (errori) {
        return false;
      }

      return true;
    };

    this.modificaConto = function () {
      //Controlla che un conto sia stato selezionato
      if (!self.datiValidi()) {
        return;
      }

      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseModificaConto(self.numeroRapportoDaModificare, self.ndg, self.codiceContrattoSelezionato)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.postVenditaSrvc.spinner.callStack--;
            return;
          }

          self.messaggiFctr.addMessage({
            type: 'I',
            message: 'Richiesta effettuata correttamente'
          });
          self.isModificaConto = false;
          self.numeroRapportoDaModificare = null;
        })
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.avviaModificaConto = function (row) {
      self.codiceContrattoSelezionato = row.entity.codiceContratto;
      self.idContrattoSelezionato = row.entity.id;
      self.isModificaConto = true;
      self.isAggiuntaCarte = false;
      self.isRestituzioneCarte = false;
      self.numeroCarteDaAggiungere = null;
      self.messaggiFctr.resetMessages();
      self.recuperaConti(self.ndg);
    };

    /**
     * @ngdoc method
     * @name selezionaConto
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaConto = function (conto) {
      self.numeroRapportoDaModificare = conto.entity.numeroRapporto;
    };

    this.avviaAggiuntaCarte = function (row) {
      self.codiceContrattoSelezionato = row.entity.codiceContratto;
      self.idContrattoSelezionato = row.entity.id;
      self.isAggiuntaCarte = true;
      self.isModificaConto = false;
      self.isRestituzioneCarte = false;
      self.numeroCarteDaAggiungere = null;
    };

    this.trasloco = function () {
      self.$state.go('tlps-post-vendita-trasloco', {
        ndg: self.ndg
      });
    };

    this.selezionaCarta = function (carta) {
      self.messaggiFctr.resetMessages();
      var index = self.carteSelezionate.indexOf(carta.entity);

      if (index >= 0) {
        self.carteSelezionate.splice(index, 1);
      } else {
        self.carteSelezionate.push(carta.entity);
      }
    };

    this.risottomettiPratica = function () {
      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseRisottomettiPratica()
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.postVenditaSrvc.spinner.callStack--;
            return;
          }

          self.messaggiFctr.addMessage({
            type: 'I',
            message: 'Richiesta effettuata correttamente'
          });
        })
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    /*
     * --------------------------------------------
     *           GESTIONE OPERAZIONI
     * -------------------------------------------
     */

    this.aggiungiCarte = function () {
      self.messaggiFctr.resetMessages();
      self.postVenditaSrvc.spinner.callStack++;
      self.postVenditaSrvc
        .promiseAggiungiCarte(self.ndg, self.numeroCarteDaAggiungere, self.codiceContrattoSelezionato)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.postVenditaSrvc.spinner.callStack--;
              return;
            }

            if (response.data.result) {
              messaggiFctr.addMessage({
                type: 'I',
                message: 'Richiesta effettuata correttamente'
              });

              self.isAggiuntaCarte = false;
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.openModaleRevocaContratto = function (row) {
      self.postVenditaSrvc.contrattoDaRevocare = row;
      self.postVenditaSrvc.ndgContrattoDaRevocare = self.ndg;
      self.$uibModal
        .open({
          animation: true,
          templateUrl: CONSTANTS.BASE_ROOT + 'components/tlpsProposta/tlpsModale/tlpsRevoca.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function (res) {});
    };

    // this.revocaContratto = function (row) {
    //   self.messaggiFctr.resetMessages();
    //   self.postVenditaSrvc.spinner.callStack++;

    //   self.postVenditaSrvc
    //     .promiseRevocaTelepass(self.ndg, row)
    //     .then(function (response) {
    //       if (self.messaggiFctr.processaResponse(response)) {
    //         self.postVenditaSrvc.spinner.callStack--;
    //         return;
    //       }
    //       messaggiFctr.addMessage({
    //         type: 'I',
    //         message: 'Richiesta effettuata correttamente',
    //       });

    //       self.recuperaContratti();
    //     })
    //     .finally(function () {
    //       self.postVenditaSrvc.spinner.callStack--;
    //     });
    // };

    this.restituisciCarte = function () {
      self.messaggiFctr.resetMessages();
      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseRestituisciCarte(self.ndg, self.carteSelezionate, self.codiceContrattoSelezionato)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.postVenditaSrvc.spinner.callStack--;
              return;
            }
            if (response.data.result) {
              messaggiFctr.addMessage({
                type: 'I',
                message: 'Richiesta effettuata correttamente'
              });
              self.isRestituzioneCarte = false;
              self.recuperaCarte(self.idContrattoSelezionato, self.ndg);
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.recuperaContratti = function () {
      self.messaggiFctr.resetMessages();
      self.ndg = self.$stateParams.ndg;
      self.numeroRapportoDaModificare = null;

      self.postVenditaSrvc.spinner.callStack++;
      // Recupero il codice cliente per farlo visualizzare
      self.postVenditaSrvc.promiseRecuperaContrattiCliente(self.ndg).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          self.postVenditaSrvc.contrattiCliente = response.data.result;

          // Se ho i dati della pratica e il codiceContratto della pratica vuol dire che la devo
          // risottomettere
          if (self.postVenditaSrvc.datiPratica && self.postVenditaSrvc.datiPratica.codiceContratto) {
            // self.postVenditaSrvc.datiPratica.stato ===
            //   self.CONSTANTS.STATO_PRATICA.DAREVISIONARE
            self.postVenditaSrvc.contrattiCliente = self.postVenditaSrvc.contrattiCliente.filter(function (item) {
              return item.codiceContratto === self.postVenditaSrvc.datiPratica.codiceContratto;
            });

            self.selectedButtonsCellTemplate = self.risottomettiButtonCellTemplate;
          }

          self.tableHeight = response.data.result.length * 35 + 40;
          self.postVenditaSrvc.spinner.callStack--;

          // // Configurazione tabella
          var _defaultRowheight = 35;
          self.gridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            // multiSelect: true,
            showHeader: true,
            enableRowHeaderSelection: false,
            // enableRowSelection: true,
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            rowHeight: _defaultRowheight,
            columnDefs: [
              {
                displayName: 'Codice Contratto',
                field: 'codiceContratto',
                width: '8%',
                name: 'codiceContratto'
              },
              {
                displayName: 'Settore',
                field: 'settore',
                width: '8%',
                name: 'settore'
              },
              {
                displayName: 'Data Apertura',
                field: 'dataAperturaContratto',
                width: '10%',
                name: 'dataAperturaContratto'
              },
              {
                displayName: 'Numero modulo apertura',
                field: 'numeroModulo',
                width: '5%',
                name: 'numeroModulo'
              },
              {
                displayName: 'Numero rapporto TLP',
                field: 'numeroRapportoTLP',
                width: '10%',
                name: 'numeroRapportoTLP'
              },
              {
                displayName: 'IBAN',
                field: 'iban',
                width: '10%',
                name: 'iban'
              },
              {
                displayName: 'Apparati',
                field: 'numeroApparati',
                width: '5%',
                name: 'numeroApparati'
              },
              {
                displayName: 'Carte',
                field: 'numeroCarte',
                width: '8%',
                name: 'numeroCarte'
              },
              {
                displayName: 'Azioni',
                field: 'numeroCarte',
                width: '36%',
                name: 'azioni',
                cellTemplate:
                  '<span>' +
                  '<span style="margin: 5px;">' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.openModaleRevocaContratto(row.entity.codiceContratto)">Revoca</button>' +
                  '</span>' +
                  '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaRestituzioneCarte(row)">Restituisci</button>' +
                  '</span>' +
                  '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaAggiuntaCarte(row)">Aggiungi</button>' +
                  '</span>' +
                  '<span>' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaModificaConto(row)">Modifica Conto</button>' +
                  '</span>' +
                  '</span>'
              }
            ],
            data: self.postVenditaSrvc.contrattiCliente,
            onRegisterApi: function (gridApi) {
              self.gridApi = gridApi;
              self.gridApi.grid.modifyRows(self.gridOptions.data);
            }
          };
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.postVenditaSrvc.spinner.callStack--;
        }
      );
    };

    this.recuperaCarte = function (contratto, ndg) {
      self.messaggiFctr.resetMessages();
      self.carteViacard = [];
      self.postVenditaSrvc.spinner.callStack++;
      self.postVenditaSrvc
        .promiseRecuperaCarteViacardPerContratto(contratto, ndg)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.postVenditaSrvc.spinner.callStack--;
              return;
            }

            self.carteViacard = response.data.result;

            self.tableHeightCarteViacard = response.data.result.length * 30 + 40;

            // // Configurazione tabella
            var _defaultRowheight = 30;
            self.gridOptionsCarteViacard = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: true,
              showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: true,
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              rowHeight: _defaultRowheight,
              columnDefs: [
                {
                  displayName: 'Numero Carta',
                  field: 'numeroCarta',
                  width: '100%',
                  name: 'numeroCarta'
                }
              ],
              data: self.carteViacard,
              onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.grid.modifyRows(self.gridOptions.data);

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                  self.selezionaCarta(row);
                });
              }
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };
    /*
     * -------------------------------------
     *           INIZIALIZZAZIONE
     * -------------------------------------
     */

    self.recuperaContratti();
  };

  TlpsPostVenditaTelepassCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPostVenditaSrvc',
    'uiGridConstants',
    '$state',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsPostVenditaTelepass/tlpsPostVenditaTelepass.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsPostVenditaTelepassCtrl = {
    bindings: {},
    controller: TlpsPostVenditaTelepassCtrl,
    controllerAs: 'postVenditaTelepassCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.telepass.wa').component('tlpsPostVenditaAll', TlpsPostVenditaTelepassCtrl);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsPostVendita/tlpsPostVenditaTelepass/tlpsPostVenditaTelepass.cmpt.js
// module id = 21
// module chunks = 0